import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { CpRefundOnlineProcessRequestModel } from '../../helpers/objects/request/refund-online-process/cp-refund-online-process-request-model';
import { CpRefundOnlineProcessResponseModel } from '../../helpers/objects/response/refund-online-process/cp-refund-online-process-response-model';

@Injectable({
  providedIn: 'root'
})
export class CpOnlineProcessService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  getAll(token: string, request: CpRefundOnlineProcessRequestModel): Observable<CpRefundOnlineProcessResponseModel> {
    const params = new HttpParams({
      fromObject: request as any
    });

    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/refunds-requests', { params })
      .pipe(map((response) => response.body as CpRefundOnlineProcessResponseModel));
  }
}
